import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { TextFieldInput } from '../../../../components/common/TextField'
import { isValid as isCpfValid } from '@fnando/cpf'
import { CfcsOrigemAutocomplete } from '../../../../components/cfcs/CfcsOrigemAutocomplete'
import { ConsultarStore, TState } from '../ConsultarStore'
import { Button, notification } from 'antd'
import { useHistory } from 'react-router-dom'
import { homePath } from '../../../../App'

const Login = () => {
  const { Layout, Container } = Login

  return (
    <Layout>
      <Container>
        <FormLogin />
      </Container>
    </Layout>
  )
}
Login.Layout = styled.div`
  display: flex;
  justify-content: center;
`
Login.Container = styled.div`
  margin-top: 100px;
  text-align: center;
  width: 400px;
  padding: 10px;
  background: white;
  border-radius: 4px;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.25);
`

const FormLogin = () => {
  const { Layout, BtnLogin, validate } = FormLogin
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  const state = ConsultarStore.useState()
  const dispatch = ConsultarStore.useDispatch()

  const handleClick = async () => {
    const { valid, message } = await validate(state)
    if (!valid) return notification.error({ message })

    try {
      setLoading(true)
      await dispatch(ConsultarStore.thunks.login())
      history.push(`${homePath}/consultar`)
    } catch (error: any) {
      notification.error({ message: error?.response?.data?.message || 'Erro ao validar!' })
      console.log(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Layout>
      <CfcOrigem />
      <SocioAdminCpf />
      <BtnLogin size="large" onClick={handleClick} loading={loading}>
        Entrar
      </BtnLogin>
    </Layout>
  )
}
FormLogin.Layout = styled.div`
  text-align: left;
  display: grid;
  row-gap: 30px;
`
FormLogin.BtnLogin = styled(Button)`
  margin-left: auto;
  width: 100px;
`
FormLogin.validate = (state: TState) => {
  const { cfcOrigemCnpj, socioAdminCpf } = state

  const invalid = (message: string) => ({ valid: false, message })

  if (!cfcOrigemCnpj) return invalid('Informe o CFC de origem!')
  if (!isCpfValid(socioAdminCpf)) return invalid('CPF do sócio administrador inválido!')

  return { valid: true, message: '' }
}

const CfcOrigem = () => {
  const dispatch = ConsultarStore.useDispatch()

  return (
    <CfcsOrigemAutocomplete
      label="CFC de origem:"
      onChange={() => dispatch(ConsultarStore.actions.changeCfcOrigemCnpj(null))}
      onSelect={(value: any, option: any) =>
        dispatch(ConsultarStore.actions.changeCfcOrigemCnpj(option.cfccnpj))
      }
      showDescription
    />
  )
}

const SocioAdminCpf = () => {
  const { socioAdminCpf } = ConsultarStore.useState()
  const dispatch = ConsultarStore.useDispatch()

  const handleChange = (e: any) => {
    dispatch(ConsultarStore.actions.changeSocioAdminCpf(e.target.value))
  }

  return (
    <TextFieldInput
      name="socioAdminCpf"
      mask="cpf"
      label="CPF do sócio administrador:"
      onChange={handleChange}
      onPaste={handleChange}
      value={socioAdminCpf}
      style={{
        fontSize: '13pt',
      }}
    />
  )
}

export default Login
